/**
 * @module beebee-base/lib/utility/pagination
 * @description Pagination utilities.
 *
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — windowed page-link list generator, re-exported
 *              through the ../utility.js barrel; backs the bb-paginator
 *              component
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      no addon imports (pure function)
 *   siblings:  sibling lib/utility/*.js modules aggregated by ../utility.js
 *              (the public `beebee-base/lib/utility` barrel import path);
 *              consumed by components/bb-paginator.js
 *   tests:     tests/unit/components/bb-paginator-test.js,
 *              tests/unit/lib/utility-test.js,
 *              tests/unit/lib/utility-wave4-test.js,
 *              tests/unit/lib/utility-wave5-test.js
 *   gotchas:   `total_page`/`page` are coerced with `Number()`; a
 *              non-finite/invalid page clamps to 1, and totals under 2 pages
 *              return an empty list (nothing to paginate).
 */

/**
 * Genera la lista delle pagine per la paginazione
 * @param {number|string} total_page - Numero totale di pagine
 * @param {number|string} page - Pagina corrente
 * @returns {Array<Object>} Lista pagine con nome, link e classe
 */
function paginatorPageLists(total_page, page) {
  const totalPages = Number(total_page);
  const pageLists = [];
  if (!Number.isFinite(totalPages) || totalPages < 2) {
    return pageLists;
  }
  const parsedPage = Number(page);
  const currentPage = Number.isFinite(parsedPage) ? Math.min(totalPages, Math.max(1, parsedPage)) : 1;
  const start = Math.max(1, currentPage - 3);
  const end = Math.min(totalPages, currentPage + 3);

  // Prima pagina e separatore
  if (start > 1) {
    pageLists.push({
      name: 1,
      link: 1
    });
    if (start > 2) {
      pageLists.push({
        name: '...',
        link: 2
      });
    }
  }

  // Pagine nel range visibile
  for (let i = start; i <= end; i++) {
    pageLists.push({
      name: i,
      link: i
    });
  }

  // Separatore e ultima pagina
  if (end < totalPages) {
    if (end < totalPages - 1) {
      pageLists.push({
        name: '...',
        link: totalPages - 1
      });
    }
    pageLists.push({
      name: totalPages,
      link: totalPages
    });
  }

  // Marca pagina attiva
  const activePage = pageLists.find(item => item.link === currentPage);
  if (activePage) {
    activePage.class = 'active';
  }
  return pageLists;
}

export { paginatorPageLists };
//# sourceMappingURL=pagination.js.map
